





































import Component from 'vue-class-component';
import LoginContainer from '@/views/authentication/login-container/LoginContainer.component';
import { Prop, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { ResetPasswordRequest } from '@/models/request/ResetPasswordRequest';
import {
  IS_RECAPTCHA_V2_USED,
  RESET_PASSWORD,
  SET_AUTH_ERRORS,
  SET_AUTH_LOADING_MODE,
} from '@/types/authentication.types';
import { RecaptchaNamespace } from '@/globals/recaptcha-namespace.global';

@Component({
  components: {
    LoginContainer,
  },
})
export default class ResetPasswordComponent extends Vue {

  @Prop(String) public resetPwToken!: string;
  @Prop(String) public indexNum!: number;

  @Action(RESET_PASSWORD, StoreNamespace.AUTHENTICATION) public resetPassword;

  @Mutation(SET_AUTH_ERRORS, StoreNamespace.AUTHENTICATION) public setAuthErrors;
  @Mutation(SET_AUTH_LOADING_MODE, StoreNamespace.AUTHENTICATION) public setAuthLoadingMode;

  @Getter(IS_RECAPTCHA_V2_USED, StoreNamespace.AUTHENTICATION) public isRecaptchaV2Used!: boolean;

  private resetPwdAuth: ResetPasswordRequest = {} as ResetPasswordRequest;
  private newPasswordRepeat: string = '';

  public mounted(): any {
    if (!this.resetPwToken) {
      return this.$router.push({ name: 'not-found' });
    }
    this.resetPwdAuth.resetPwToken = this.resetPwToken;
    this.resetPwdAuth.indexNum = this.indexNum;
  }

  public async onLogin(recaptchaV2Response: string): Promise<void> {
    if (this.resetPwdAuth.password === this.newPasswordRepeat) {
      this.resetPassword({
        ...(this.isRecaptchaV2Used && { recaptchaV2Response }),
        recaptchaResponse: this.$recaptcha && await this.$recaptcha(RecaptchaNamespace.RESET_PASSWORD),
        resetPwToken: this.resetPwdAuth.resetPwToken,
        indexNum: this.resetPwdAuth.indexNum,
        userId: this.resetPwdAuth.userId,
        password: this.resetPwdAuth.password,
      });
    } else {
      this.setAuthErrors([this.$t('login.passwords_not_matched').toString()]);
      this.setAuthLoadingMode(false);
    }
  }

}
